import { render, staticRenderFns } from "./UsuarioDetails.vue?vue&type=template&id=056cd87f&scoped=true"
import script from "./UsuarioDetails.vue?vue&type=script&lang=js"
export * from "./UsuarioDetails.vue?vue&type=script&lang=js"
import style0 from "./UsuarioDetails.vue?vue&type=style&index=0&id=056cd87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cd87f",
  null
  
)

export default component.exports